import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  inject,
} from "@angular/core";
import { RouterLink, RouterLinkActive } from "@angular/router";
import { ItemsPrivatePage, itemsPrivatePage } from "@models/items-private-page";
import { CommonModule, NgClass } from "@angular/common";
import { AvatarComponent } from "@shared/components/avatar/avatar.component";
import { SessionService } from "@shared/components/core/stores/session.service";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { appVersion as version } from "@env/version";

type LangOpt = { code: string; label: string; flag?: string };

@Component({
  selector: "app-private-sidebar",
  standalone: true,
  imports: [
    RouterLink,
    RouterLinkActive,
    NgClass,
    AvatarComponent,
    CommonModule,
    TranslateModule,
  ],
  templateUrl: "./private-sidebar.component.html",
  styleUrl: "./private-sidebar.component.scss",
})
export class PrivateSidebarComponent implements OnInit {
  @Input() opened = true;
  @Input() isMobile = false;

  @Input() userName = "";
  @Input() userImageUrl = "";

  @Output() navigate = new EventEmitter<void>();
  @Output() close = new EventEmitter<void>();
  version = version;

  protected readonly items: ItemsPrivatePage[] = JSON.parse(
    JSON.stringify(itemsPrivatePage)
  );
  expandedStates: boolean[] = [];

  private readonly session = inject(SessionService);
  public readonly translate = inject(TranslateService);

  currentLang = "pt";
  languages: LangOpt[] = [
    { code: "pt", label: "Português" },
    { code: "en", label: "English" },
    { code: "es", label: "Español" },
  ];

  ngOnInit(): void {
    this.expandedStates = this.filteredItems.map(() => false);

    const userId = this.session.user()?.id;
    const saved = userId
      ? localStorage.getItem(`appLang_${userId}`)
      : localStorage.getItem("appLang");

    if (saved) {
      this.currentLang = saved;
      this.translate.use(saved);
    } else {
      this.currentLang = this.translate.currentLang || "pt";
    }
  }

  changeLanguage(lang: string) {
    this.currentLang = lang;
    this.translate.use(lang);

    const userId = this.session.user()?.id;
    if (userId) localStorage.setItem(`appLang_${userId}`, lang);
    else localStorage.setItem("appLang", lang);
  }

  get filteredItems(): ItemsPrivatePage[] {
    const list = this.items.filter((i) => i.sidebarActive);
    for (const item of list) {
      if (Array.isArray(item.children))
        item.children = item.children.filter((c) => c.sidebarActive);
    }
    return list;
  }

  toggleExpand(i: number) {
    this.expandedStates[i] = !this.expandedStates[i];
  }

  get displayName(): string {
    return this.userName || this.session.user()?.name || "—";
  }

  get displayImageUrl(): string {
    if (this.userImageUrl) return this.userImageUrl;
    const raw = this.session.user()?.photo?.trim();
    if (!raw) return "";
    if (/^https?:\/\//i.test(raw)) return raw;
    return raw.startsWith("/") ? raw : `/${raw}`;
  }
}
